import styled from 'styled-components';
import { theme } from 'styled-tools';

export const FormItemContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: column;
`;

export const LabelWrapper = styled.div``;

export const InputWrapper = styled.div`
    width: 100%;
    margin-top: 8px;
`;


export const CaptionWrapper = styled.div`
    ${theme('divStyle.margin_bottom_4')}
`;

export const OptionalChildrenWrapper = styled.div`
    ${theme('divStyle.margin_bottom_4')}
`;
